import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import Navbar from './Components/Navbar/Navbar'
import Home from './Components/Home/Home'
import About from './Components/About/About'
import Experiences from './Components/Experiences/Experiences'
import Contact from './Components/Skills/Contact'
import Pricing from './Components/PriceL/Pricing'
import { Offline } from 'react-detect-offline'




export default function App() {

  return <BrowserRouter>
      <Navbar/>
      <Home/>
      <About/>
      <Experiences/>
      <Pricing/>
      <Contact/>
      <Offline>  <div className='network'><i class="fa-solid fa-triangle-exclamation"></i> You're offline ! </div></Offline>
      
  </BrowserRouter>

 

    

 

  
}
